import { Send, MessageCircle, Mail } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { useContent } from "../contexts/ContentContext";
import { Reveal } from "../components/Reveal";
import { ContactForm } from "../components/ContactForm";
import { PageHero } from "../components/Shared";

const HERO_IMG =
  "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1920&q=80";

export default function Contacts() {
  const { t } = useI18n();
  const { content } = useContent();
  const ch = content?.channels || {};
  const channels = [
    {
      key: "telegram",
      label: t.contacts.channels.telegram,
      handle: ch.telegram_handle || "@diyatour",
      href: ch.telegram_url || "https://t.me/diyatour",
      icon: MessageCircle,
    },
    {
      key: "whatsapp",
      label: t.contacts.channels.whatsapp,
      handle: ch.whatsapp_handle || "+86 000 000 0000",
      href: ch.whatsapp_url || "https://wa.me/0000000000",
      icon: MessageCircle,
    },
    {
      key: "wechat",
      label: t.contacts.channels.wechat,
      handle: ch.wechat_handle || "diyatour",
      href: "#",
      icon: MessageCircle,
    },
    {
      key: "email",
      label: t.contacts.channels.email,
      handle: ch.email || "hello@diyatour.com",
      href: `mailto:${ch.email || "hello@diyatour.com"}`,
      icon: Mail,
    },
  ];

  return (
    <>
      <PageHero
        overline={t.contacts.overline}
        title={t.contacts.title}
        desc={t.contacts.desc}
        image={t.contacts.heroImage || HERO_IMG}
      />

      <section className="bg-midnight">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <Reveal className="lg:col-span-5">
            <div className="overline mb-6">CHANNELS · 渠道</div>
            <h2 className="font-display font-extrabold tracking-tighter text-white text-3xl md:text-4xl leading-tight mb-10 uppercase">
              Выберите удобный канал связи
            </h2>
            <div className="space-y-px bg-white/5">
              {channels.map(({ key, label, handle, href, icon: Icon }) => (
                <a
                  key={key}
                  href={href}
                  data-testid={`contact-channel-${key}`}
                  target={href.startsWith("http") ? "_blank" : undefined}
                  rel="noreferrer"
                  className="group flex items-center justify-between gap-6 bg-midnight-2 p-6 hover:bg-coral hover:text-midnight transition-colors"
                >
                  <div className="flex items-center gap-5">
                    <div className="w-11 h-11 border border-white/15 group-hover:border-midnight group-hover:text-midnight flex items-center justify-center transition-colors">
                      <Icon size={18} />
                    </div>
                    <div>
                      <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-coral group-hover:text-midnight">
                        {label}
                      </div>
                      <div className="font-display font-bold text-white group-hover:text-midnight text-lg mt-0.5">
                        {handle}
                      </div>
                    </div>
                  </div>
                  <Send size={18} className="text-white/40 group-hover:text-midnight transition-colors" />
                </a>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-7">
            <div className="bg-midnight-2 p-8 md:p-12 relative overflow-hidden border border-white/5">
              <div className="absolute inset-0 tech-grid-bg opacity-50" />
              <div className="relative">
                <div className="overline mb-4">FORM · 表单</div>
                <h2 className="font-display font-extrabold tracking-tighter text-white text-3xl md:text-4xl leading-tight mb-8 uppercase">
                  {t.contacts.formTitle}
                </h2>
                <ContactForm />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
